module.exports = __webpack_public_path__ + "static/media/a_02.d5253736.jpg";